import './CvTheque.scss';

// import 'react-quill/dist/quill.bubble.css';
import { Add, DeleteForeverOutlined, ExpandMore, Favorite, FavoriteBorder, Link, StarBorder, Visibility, VisibilityOutlined } from '@mui/icons-material';
// import { cvThequeColumns } from './CvTheque';
import { Autocomplete, Button, FormControl, IconButton, MenuItem, Select, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import CategoriesSubCategoriesDropDown from '../../../Components/CategoriesSubCategoriesDropDown';
import DialogClasserCvs from '../../../Components/Dialogs/DialogClasserCvs';
import DialogLierCvs from '../../../Components/Dialogs/DialogLierCvs';
import CvAnonyme from '../../../Components/Docs/CvAnonyme';
import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
// import SearchCity from '../../../Components/shared/SearchCity';
import SearchCityByRegions from '../../../Components/shared/SearchCityByRegions';
import { exigencesEnum, experienceTotal, foncSkillSet, genreList, languesList, modeTravailEnum, niveauxLangue, niveauxSkill, niveauxSkillAo } from '../../../data/Interfaces';
import { InitSearchSVG } from '../../../data/SVGs';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateTotalAnneeExperience, getDateDisponibilite, getExpertCompetences, getNomPrenomAnonymeFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { getPaymentSimulationResults } from '../../../Utils/utilsCraX';
import CompetenceComponent from '../../Admin/GestionExpert/CompetenceComponent';
import {initializeCertifCvTheque, initializeFoncSkill, initializeLangue, initializeTechSkill } from '../AO/CreateAOThird';
import { convertMongoDocIntoMongooseOne } from './CvThequeSimpleSearch';
const SEARCH_MODE = 'IA';
// const SEARCH_MODE = 'BD';
function CvThequeAdvancedSearch() {
    const { addEuro4Decimal } = useNumberFormatting();

    const { inputSize } = useWindowSize();
    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const { ListStatutCv, setListStatutCv } = useCraRdv();

    const [categorie, setCategorie] = useState('');
    const [sousCategorie, setSousCategorie] = useState('');
    const [minimumAnneeExp, setMinimumAnneeExp] = useState(null);

    // const [experts, setExperts] = useState([]);
    const [expert, setExpert] = useState();
    const [intitulePoste, setIntitulePoste] = useState();
    const [selectedExperts, setSelectedExperts] = useState([]);
    //const {cvListStatut,setCvListStatut} = useCraRdv();
    const [cvOpen, setCvOpen] = useState(false);
    const [cvthequeExperts, setCvthequeExperts] = useState([]);
    const { i18n } = useTranslation();
    const [openClasser, setOpenClasser] = useState(false);
    const [openLier, setOpenLier] = useState(false);

    // const initialCompetenceObject = { competence: '',niveau:'',experience:'',exigence:''};
    // const initialLangueObject = { langue: '',niveau:'',exigence:''};
    // const initialCertifObject = { certificat: '',exigence:''};
    const [skillsTech, setSkillsTech] = useState([]);
    // const [skillsTech, setSkillsTech] = useState([initialCompetenceObject]);
    // const [skillsFonc, setSkillsFonc] = useState([initialCompetenceObject]);
    const [skillsFonc, setSkillsFonc] = useState([]);
    // const [langues, setLangues] = useState([initialLangueObject]);
    // const [certifs, setCertifs] = useState([initialCertifObject]);.
    const [langues, setLangues] = useState([]);

    const [certifs, setCertifs] = useState([]);
    // const [localisation,setLocalisation]=useState();
    const [paysResidence, setPaysResidence] = useState('');
    const [regionResidence, setRegionResidence] = useState('');
    const [villeResidence, setVilleResidence] = useState('');
    const {device}=useWindowSize();

    useEffect(() => {
        search(true);
    }, []);

    const loadDataToTheTable = (experts, isInitialRequest) => {
        let Array1 = [];
        let annExp = 0;
        if (SEARCH_MODE == 'BD' || isInitialRequest) {
            experts?.map((expert, i) => {
                console.log('candidatttttttttt', expert, i);
                annExp = expert?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(expert?.proData?.experiences);
                Array1.push({
                    'id': expert?._id,
                    'matching': '%',
                    'titre': expert?.persoData?.genre,
                    'nom': getNomPrenomAnonymeFromPersoData(expert?.persoData),
                    'intitulePoste': expert?.persoData?.intitulePoste,
                    // to discuss : bcp de competences => comment on va les afficher ? et est ce que on peux afficher 20 competences !!
                    'competences': getExpertCompetences(expert?.proData?.competencesTechnique),
                    //'favoris':getStatutCv('favoris',ListStatutCv,expert?._id)==' ' ? 'nonFav' : getStatutCv('favoris',ListStatutCv,expert?._id),
                    //'statutCv' : getStatutCv('Lu',ListStatutCv,expert?._id)==' ' ? 'Non lu' : getStatutCv('Lu',ListStatutCv,expert?._id),
                    'tauxJournalier': getPaymentSimulationResults({ tj: expert?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                    'ville': expert?.preference?.residence?.ville,
                    'pays': expert?.preference?.residence?.pays,
                    //'evaluation': (expert?.recommendation?.evaluation+ '4.5'),
                    //'commentaire': (expert?.recommendation?.commentaire),
                    // TODO: later add this with the user updatedAt
                    'DerniereActivite': formatDateJJMMYYYY(expert?.updatedAt),
                    // ? !! donnees a discuter
                    'tatalAnneeExperience': annExp,
                    'dateDisponibilite': getDateDisponibilite(expert?.preference?.dateDisponibilite),
                    'modeTravail': expert?.preference?.modeTravail?.type,
                    ...expert
                });
            });
        }
        else if (SEARCH_MODE == 'IA') {
            experts?.map((expert, i) => {
                console.log('candidatttttttttt', expert, i);
                const expertData = convertMongoDocIntoMongooseOne(expert?.expertData);
                annExp = expertData?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(expertData?.proData?.experiences);
                Array1.push({
                    'id': expert?.expert_id,
                    '_id': expert?.expert_id,
                    // '_id': expert?.expert_id['$oid'],
                    // '_id': JSON.parse(expert?._id)[0]?.$oid,
                    'matching': addEuro4Decimal((expert?.matching_score * 100).toFixed(2), '%'),
                    'titre': expertData?.persoData?.genre,
                    'nom': getNomPrenomAnonymeFromPersoData(expertData?.persoData),
                    'intitulePoste': expertData?.persoData?.intitulePoste,
                    // to discuss : bcp de competences => comment on va les afficher ? et est ce que on peux afficher 20 competences !!
                    'competences': getExpertCompetences(expertData?.proData?.competencesTechnique),
                    //'favoris':getStatutCv('favoris',ListStatutCv,expert?._id)==' ' ? 'nonFav' : getStatutCv('favoris',ListStatutCv,expert?._id),
                    //'statutCv' : getStatutCv('Lu',ListStatutCv,expert?._id)==' ' ? 'Non lu' : getStatutCv('Lu',ListStatutCv,expert?._id),
                    'tauxJournalier': getPaymentSimulationResults({ tj: expertData?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                    'ville': expertData?.preference?.residence?.ville,
                    'pays': expertData?.preference?.residence?.pays,
                    //'evaluation': (expert?.recommendation?.evaluation+ '4.5'),
                    //'commentaire': (expert?.recommendation?.commentaire),
                    // TODO: later add this with the user updatedAt
                    'DerniereActivite': formatDateJJMMYYYY(expertData?.updatedAt),
                    // ? !! donnees a discuter
                    'tatalAnneeExperience': addEuro4Decimal(annExp, 'ans'),
                    'dateDisponibilite': getDateDisponibilite(expertData?.preference?.dateDisponibilite),
                    'modeTravail': expertData?.preference?.modeTravail?.type,
                    ...expertData
                });
            });
        }
        console.log('Array1', Array1);
        setCvthequeExperts(Array1);
    };

    const search = async (isInitialRequest = false) => {
        setBackdropOpen(true);
        if (SEARCH_MODE == 'BD' || isInitialRequest)
            try {
                const response1 = await axiosPrivate.post('/cvTheque/searchExpert',
                    // { searchedSkillsTech },
                );
                loadDataToTheTable(response1.data.experts,isInitialRequest );
                // setExperts(response1.data.experts);
                // setExpertsOrigine(response1.data.experts);
                setBackdropOpen(false);
            } catch (error) {
                console.log(error.response?.status);
                Swal.fire({
                    // text: error
                    text: i18n.t(error.response?.data.error)
                });
            }
        else if (SEARCH_MODE == 'IA')
            try {
                const response1 = await axiosPrivate.post('/proxy/advanced_search',

                    {
                        'categorie': {
                            'value': categorie,
                            'sousCategorie': sousCategorie, //(par defaut: allSubCategories)
                        },
                        'intitule': intitulePoste, // si on envoie ' ' espace ca va minimiser les scores car on va utiliser les traitement IA avec les similarite
                        'min_experience': minimumAnneeExp,
                        'mobilite': {
                            ville: villeResidence,
                            region: regionResidence,
                            pays: paysResidence,
                        },
                        'tech_skills': skillsTech.filter((skill) => skill?.titre != ' ' && skill?.titre != '' && skill?.titre),
                        //  [
                        // {
                        //     'titre': 'Spring',
                        //     'niveau': 'expert',
                        //     'exigence': 'exige'
                        // }
                        // ],
                        'fonc_skills': skillsFonc.filter((skill) => skill?.titre != ' ' && skill?.titre != '' && skill?.titre),
                        'langues': langues.filter((lang) => lang?.langue != ' ' && lang?.langue != '' && lang?.langue),
                        // [
                        //     {
                        //         'langue': 'French',
                        //         'niveau': 'avance',
                        //         'exigence': 'exige'
                        //     },
                        // ],
                        'certifs': certifs.filter((certif) => certif?.titre != ' ' && certif?.titre != '' && certif?.titre)
                        // [
                        //     {
                        //         'cerificat': 'Oracle JAVA',
                        //         'exigence': 'exige'
                        //     }
                        // ]
                    },
                );
                loadDataToTheTable(response1.data,isInitialRequest);
                // setExperts(response1.data);
                // setExpertsOrigine(response1.data);
                setBackdropOpen(false);
            } catch (error) {
                setBackdropOpen(false);
                console.log(error.response?.status);
                // Swal.fire({
                //     // text: error
                //     text: error.response?.data.error
                // });
            }
    };

    const handleInitialiseSearch = () => {
        setCategorie('');
        setSousCategorie('');
        setMinimumAnneeExp(null);
        setIntitulePoste('');
        setSkillsTech([]);
        setSkillsFonc([]);
        setLangues([]);
        setCertifs([]);
        setPaysResidence('');
        setRegionResidence('');
        setVilleResidence('');
        setSelectedRow(null);
        setSelectedExperts([]);
        search(true);

        // search();
    };

    const cvThequeColumns = [
        {
            field: 'matching',
            title: i18n.t('Matching'),
            //enableRowSpan: true,
            //Filter: FilterForm,
        },
        {
            field: 'favoris',
            title: i18n.t('Favoris'),
            render: rowData => {
                const isFavoris = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('favoris'));

                const handleFavoriteClick = () => {
                    setListStatutCv(prevListStatutCv => {
                        let updatedListStatutCv = [...prevListStatutCv];
                        const index = updatedListStatutCv.findIndex(obj => obj.id === rowData?.id);

                        if (index === -1) {
                            updatedListStatutCv.push({ id: rowData?.id, statut: ['favoris'] });
                        } else {
                            if (!updatedListStatutCv[index]['statut'].includes('favoris')) {
                                updatedListStatutCv[index]['statut'].push('favoris');
                            } else {
                                updatedListStatutCv[index]['statut'] = updatedListStatutCv[index]['statut'].filter(s => s !== 'favoris');
                            }
                        }

                        console.log('ListStatutCv', updatedListStatutCv, 'rowdata id', rowData?.id);
                        return updatedListStatutCv;
                    });
                };

                return (
                    <>
                        {isFavoris ? (
                            <Favorite onClick={handleFavoriteClick} />
                        ) : (
                            <FavoriteBorder onClick={handleFavoriteClick} />
                        )}
                    </>
                );
            },
        },
        {
            field: 'eye',
            title: i18n.t('CV'),
            render: rowData => {
                let found = ListStatutCv.find(el => el?.id == rowData?.id);
                if (found == undefined || (found != undefined && !found['statut'].includes('Lu')))
                    return (
                        <VisibilityOutlined
                            onClick={() => {
                                setExpert(rowData);

                                //code pour éviter d'avoir des experts redondants, si l'expert
                                //existe déjà nous l'ajoutons avec le statut désiré sinon nous
                                //recherchons l'index d'expert et on lui ajout le statut dans sa
                                //liste des statuts.
                                let arr = ListStatutCv;
                                const index = arr.findIndex(obj => {
                                    return obj.id === rowData?.id;
                                });
                                console.log('index', index);
                                if (index == -1)
                                    arr.push({ id: rowData?.id, statut: ['Lu'] });
                                else {
                                    if (!arr[index]['statut'].includes('Lu'))
                                        arr[index]['statut'].push('Lu');
                                }

                                setListStatutCv(arr);
                                console.log('ListStatutCv', ListStatutCv, 'arr after select', arr);
                                setCvOpen(true);
                            }}
                        />
                    );
                else
                    return (
                        <Visibility
                            onClick={() => {
                                setExpert(rowData);
                                const arr = ListStatutCv.map(obj => {
                                    if (obj.id === rowData?.id) {
                                        return {
                                            id: obj.id,
                                            statut: obj.statut.filter(s => s !== 'Lu')
                                        };
                                    } else {
                                        return obj;
                                    }
                                });
                                //let arr=ListStatutCv;
                                //const index = arr.findIndex(obj => {
                                //    return obj.id === rowData?.id;
                                //});
                                //const index2 = arr[index]['statut'].indexOf('Lu');
                                //if (index2 !== -1) {
                                //    arr[index]['statut'].splice(index2, 1);

                                //}
                                console.log('ListStatutCv', ListStatutCv, 'arr after deseclt', arr);
                                setListStatutCv(arr);
                            }}
                        />
                    );

            }
            //<RemoveRedEye
            //    style={{cursor: 'pointer'}}
            //    onClick={() => {
            //        setExpert(rowData);
            //        setCvOpen(true);
            //        let arr=ListStatutCv;
            //        const index = arr.findIndex(obj => {
            //            return obj.id === rowData?.id;
            //        });
            //        console.log('index',index);
            //        if(index==-1)
            //            arr.push({id:rowData?.id,statut:['lu']});
            //        else if(!arr[index]['statut'].includes('lu'))
            //            arr[index]['statut']=['lu','favoris'];

            //        setListStatutCv(arr);
            //    }}
            ///>
        },
        {
            field: 'titre',
            title: i18n.t('Titre'),
            render: (rowData) =>
                searchLabelInEnumByValue(genreList, rowData.titre)
            // enableRowSpan: true
        },
        {
            field: 'nom',
            title: i18n.t('Nom'),
            // enableRowSpan: true
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé du CV'),
            // enableRowSpan: true
        },
        {
            field: 'competences',
            title: i18n.t('Compétences'),
            render: (rowData) =>
                rowData?.competences ?? getExpertCompetences(rowData?.proData?.competencesTechnique)
            // enableRowSpan: true
        },
        {
            field: 'tatalAnneeExperience',
            title: i18n.t('Total Exp.'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tatalAnneeExperience, i18n.t('ans'));
            }
        },
        {
            field: 'statutCv',
            title: i18n.t('Statut CV'),
            render: rowData => {
                //const isFavoris = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('favoris'));
                const isLu = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('Lu'));
                return (
                    <>
                        {isLu ? (
                            <p style={{ margin: '0' }}>Lu</p>
                        ) : (
                            <p style={{ margin: '0' }}>Non lu</p>
                        )}
                    </>
                );
            }
        },
        {
            field: 'dateDisponibilite',
            title: i18n.t('Date de disponibilité'),
            render: (rowData)=>
                i18n.t(rowData?.dateDisponibilite)
            //render: (rowData)=>
            //    formatDateJJMMYYYY(rowData.dateDisponibilite)

        },
        {
            field: 'tauxJournalier',
            title: i18n.t('Taux journalier'),
            render: rowData =>
                addEuro4Decimal(rowData?.tauxJournalier)
        },
        {
            field: 'modeTravail',
            title: i18n.t('Mode de travail'),
            render: (rowData) =>
                i18n.t(searchLabelInEnumByValue(modeTravailEnum, rowData.modeTravail))

        },
        {
            field: 'pays',
            title: i18n.t('Pays'),
        },
        {
            field: 'ville',
            title: i18n.t('Ville'),
        },
        {
            field: 'evaluation',
            title: i18n.t('Evaluation'),
            render: () =>
                //faut ajouter un traitement selon la notation du client soit on affiche start ou half start
                <StarBorder />
        },
        //{
        //    field: 'commentaire',
        //    title: i18n.t('Commentaire',
        //    render: () =>
        //        //faut ajouter un traitement selon la notation du client soit on affiche start ou half start
        //        <Chat />
        //},
        {
            field: 'DerniereActivite',
            title: i18n.t('Dernière activité'),
        },
    ];

    const validateForm = () => {
        // Check each TechSkill object in the list
        for (const techSkill of skillsTech) {
            // Ensure that both titre and niveau are not null
            if (techSkill.titre === null || techSkill.titre === '' || techSkill.niveau === null) {
            // If any TechSkill object does not meet the criteria, return false
                return true;
            }
        }

        for (const foncSkill of skillsFonc) {
            // Ensure that both titre and niveau are not null
            if (foncSkill.titre === null || foncSkill.titre === '' || foncSkill.niveau === null) {
            // If any TechSkill object does not meet the criteria, return false
                return true;
            }
        }

        for (const langue of langues) {
            // Ensure that both titre and niveau are not null
            if (langue.langue === null || langue.langue === '' || langue.niveau === null) {
            // If any TechSkill object does not meet the criteria, return false
                return true;
            }
        }

        // If all TechSkill objects meet the criteria, return true
        return false;
    };

    const [selectedRow, setSelectedRow] = React.useState(null);
    return (
        <>
            <div className='frame4CvTheque'>
                <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', gap: '12px', alignSelf: 'stretch' }}>
                    {device=='desktop' &&
                    <>
                        <Tooltip  title='Clear' >
                            <IconButton onClick={handleInitialiseSearch}>
                                <InitSearchSVG />
                            </IconButton>
                        </Tooltip>

                        <CategoriesSubCategoriesDropDown
                            setCategorie={setCategorie}
                            setSousCategorie={setSousCategorie}
                            sousCategorie={sousCategorie}
                            label={i18n.t('Catégories')}
                            width='25%'
                        />

                        <TextFieldComponent
                            label={i18n.t('Intitulé du poste')}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            value={intitulePoste}
                            onChange={(e) => {
                                setIntitulePoste(e.target.value);
                            }}
                            //endIcon={<AddIcon />}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            style={{ width: '52%', backgroundColor: 'white', borderRadius: '8px' }}
                        />
                        <div style={{ display: 'flex', width: '23%' }}>
                            <SelectComponent
                                val={minimumAnneeExp}
                                name={'Min années experiences'}
                                setVal={(e) => {
                                    setMinimumAnneeExp(e.target.value);
                                }}
                                label={i18n.t('Min d\'années d\'experiences')}
                                //val={lang?.langue}
                                //setVal={}
                                listVal={experienceTotal}
                            />
                        </div>

                    </>
                    }
                    {device!='desktop' &&
                    <>
                        <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                            <Tooltip  title='Clear' >
                                <IconButton onClick={handleInitialiseSearch}>
                                    <InitSearchSVG />
                                </IconButton>
                            </Tooltip>
                            <TextFieldComponent
                                label={i18n.t('Intitulé du poste')}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={intitulePoste}
                                onChange={(e) => {
                                    setIntitulePoste(e.target.value);
                                }}
                                //endIcon={<AddIcon />}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                            />
                        </div>
                        <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                            <CategoriesSubCategoriesDropDown
                                setCategorie={setCategorie}
                                setSousCategorie={setSousCategorie}
                                sousCategorie={sousCategorie}
                                label={i18n.t('Catégories')}
                                width='50%'
                            />
                            <div style={{ display: 'flex', width: '50%' }}>
                                <SelectComponent
                                    val={minimumAnneeExp}
                                    name='Min années experiences'
                                    setVal={(e) => {
                                        setMinimumAnneeExp(e.target.value);
                                    }}
                                    label={i18n.t('Min d\'années d\'experiences')}
                                    //val={lang?.langue}
                                    //setVal={}
                                    listVal={experienceTotal}
                                />
                            </div>

                        </div>

                    </>

                    }

                    {/*<FormControl sx={{width: '25%'}} >
                        <ThemeProvider theme={FieldComponentFont}>
                            <SearchCity
                                setCity={setCity}
                                width="100%"
                                city={city}
                                //width='200px'
                                label='Ville'
                                size='medium'
                            />
                        </ThemeProvider>
                    </FormControl>*/}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignSelf: 'stretch' }}>
                    <SearchCityByRegions
                        paysLocalisation={paysResidence}
                        setPaysLocalisation={setPaysResidence}
                        regionLocalisation={regionResidence}
                        setRegionLocalisation={setRegionResidence}
                        villeLocalisation={villeResidence}
                        setVilleLocalisation={setVilleResidence}
                        // * those are simple html names to be passed for the required logic
                        namePays='paysResidence'
                        nameRegion='regionResidence'
                        nameVille='villeResidence'
                    />
                </div>
            </div>

            <Accordion className='frame36CvTheque'>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className='frame37CvTheque'
                >
                    <h6 className='frame38CvTheque'>{i18n.t('Compétences techniques')}</h6>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='frame39CvTheque'>
                        <p className='frame40CvTheque'>
                            {i18n.t('Il est très recommandé de remplir tous les champs pour augmenter votre visibilité')}
                        </p>
                        {Array.isArray(skillsTech) && skillsTech.map((skill, i) => (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection:device=='desktop'? 'row':'column',
                                    justifyContent: 'space-between',
                                    alignSelf: 'stretch',
                                    gap: '16px',
                                }}
                                key={i}
                            >
                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Compétence')}</p>
                                    <CompetenceComponent
                                        skill={skill}
                                        index={i}
                                        skillsTech={skillsTech}
                                        setSkillsTech={setSkillsTech}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                    <SelectComponent
                                        val={skill?.niveau}
                                        name='niveau'
                                        setVal={(e) => {
                                            let newArr = [...skillsTech];
                                            newArr[i].niveau = e.target.value;
                                            setSkillsTech(newArr);
                                            console.log(e.target.value);
                                        }}
                                        error={skill.titre? false : true}
                                        helperText={skill.titre ? '' : i18n.t('Champ requis')}
                                        listVal={niveauxSkillAo}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                    <SelectComponent
                                        name="exigence"
                                        val={skill?.exigence}
                                        setVal={(e) => {
                                            let newArr = [...skillsTech];
                                            newArr[i].exigence = e.target.value;
                                            setSkillsTech(newArr);
                                            console.log(e.target.value);
                                        }}
                                        listVal={exigencesEnum}
                                    />
                                </div>

                                <div className='btndelete'>
                                    <IconButton
                                        onClick={(e) => {
                                            const list = [...skillsTech];
                                            list.splice(i, 1);
                                            setSkillsTech(list);

                                            // e.preventDefault()
                                            // delete the index element by distructuring the array in two part without taking the i element
                                            //let newArr = [
                                            //    ...skillsTech.slice(0, i),
                                            //    ...skillsTech.slice(i + 1, skillsTech.length),
                                            //];
                                            // let newArr = [...experienceState]; // copying the old datas array
                                            // replace e.target.value with whatever you want to change it to

                                            console.log(e, skillsTech);
                                        }}

                                        aria-label="delete"
                                    >
                                        <DeleteForeverOutlined />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                        <Button
                            style={{...buttonStyles(false),...{color:'#B0B0B0'}}}
                            variant="text"
                            startIcon={<Add />}
                            onClick={(e) => {
                                let index = skillsTech.length;
                                let newArr = [...skillsTech]; // copying the old datas array
                                newArr.push(initializeTechSkill(index));
                                setSkillsTech(newArr);
                                console.log(e, skillsTech);
                            }}
                        >{i18n.t('Ajouter une compétence')}</Button>

                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='frame36CvTheque'>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className='frame37CvTheque'
                >
                    <h6 className='frame38CvTheque'>{i18n.t('Compétences fonctionnelles')}</h6>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='frame39CvTheque'>
                        {Array.isArray(skillsFonc) && skillsFonc.map((skill, i) => (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: device=='desktop'? 'row':'column',
                                    justifyContent: 'space-between',
                                    alignSelf: 'stretch',
                                    gap: '16px',
                                }}
                                key={i}
                            >
                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Compétence')}</p>
                                    <Autocomplete
                                        id="free-solo-2-demo"
                                        name='titre'
                                        size={inputSize}
                                        freeSolo
                                        options={foncSkillSet.map((option) => option?.title)}
                                        inputValue={skill?.titre || ''}
                                        onInputChange={(event, newInputValue) => {
                                            // setInputValue(newInputValue);
                                            console.log({ event, newInputValue, skillsTech });
                                            let newArr = [...skillsFonc]; // copying the old datas array
                                            newArr[i].titre = newInputValue; // replace e.target.value with whatever you want to change it to
                                            setSkillsFonc(newArr);
                                        }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                        renderInput={(params) =>
                                            <TextFieldComponent
                                                {...params}
                                                sx={{
                                                    '& > :not(style)': { borderRadius: '8px' },
                                                }}
                                            //onChange={(e)=>{
                                            //    handleInputChangeCompetencesTech(e,i);
                                            //}}
                                            //label=""
                                            //placeholder="Compétence technique"
                                            />}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                    <SelectComponent
                                        name='niveau'
                                        val={skill?.niveau}
                                        setVal={(e) => {
                                            let newArr = [...skillsFonc]; // copying the old datas array
                                            newArr[i].niveau = e.target.value; // replace e.target.value with whatever you want to change it to
                                            setSkillsFonc(newArr);
                                        }}
                                        error={skill.titre? false : true}
                                        helperText={skill.titre ? '' : i18n.t('Champ requis')}
                                        listVal={niveauxSkill}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'24%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                    <SelectComponent
                                        name='exigence'
                                        val={skill?.exigence}
                                        setVal={(e) => {
                                            let newArr = [...skillsFonc];
                                            newArr[i].exigence = e.target.value;
                                            setSkillsFonc(newArr);
                                            console.log(e.target.value);
                                        }}
                                        listVal={exigencesEnum}
                                    />
                                </div>

                                <div className='btndelete'>
                                    <IconButton
                                        onClick={() => {
                                            const list = [...skillsFonc];
                                            list.splice(i, 1);
                                            setSkillsFonc(list);
                                        }}

                                        aria-label="delete"
                                    >
                                        <DeleteForeverOutlined />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                        <Button
                            style={{...buttonStyles(false),...{color:'#B0B0B0'}}}
                            variant="text"
                            startIcon={<Add />}
                            onClick={(e) => {
                                let index = skillsFonc.length;
                                let newArr = [...skillsFonc]; // copying the old datas array
                                newArr.push(initializeFoncSkill(index));
                                // replace e.target.value with whatever you want to change it to
                                setSkillsFonc(newArr);
                                console.log(e, skillsFonc);
                            }}
                        >{i18n.t('Ajouter une compétence')}</Button>

                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='frame36CvTheque'>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className='frame37CvTheque'
                >
                    <h6 className='frame38CvTheque'>{i18n.t('Langues')}</h6>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='frame39CvTheque'>
                        {Array.isArray(langues) && langues.map((lang, i) => (
                            <div
                                key={i}
                                style={{
                                    display: 'flex',
                                    flexDirection:device=='desktop'? 'row':'column',
                                    justifyContent: 'space-between',
                                    alignSelf: 'stretch',
                                    gap: '16px',
                                }}
                            >

                                <div style={{ width: device=='desktop'?'33%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Langue')}</p>
                                    <SelectComponent
                                        setVal={e => {
                                            const { value } = e.target;
                                            const list = [...langues];
                                            list[i].langue = value;
                                            setLangues(list);
                                        }}
                                        val={lang?.langue}
                                        name='langue'
                                        listVal={languesList}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'33%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                    <ThemeProvider theme={FieldComponentFont}>
                                        <FormControl fullWidth>
                                            <Select
                                                size={inputSize}
                                                value={lang?.niveau}
                                                onChange={(e) => {
                                                    let newArr = [...langues]; // copying the old datas array
                                                    newArr[i].niveau = e.target.value; // replace e.target.value with whatever you want to change it to
                                                    setLangues(newArr);
                                                }}
                                                error={lang.langue? false : true}
                                                helperText={lang.langue ? '' : i18n.t('Champ requis')}
                                                name='niveau'
                                                sx={{
                                                    '& > :not(style)': { borderRadius: '8px' },
                                                }}
                                                style={{ width: '100%', background: 'white' }}

                                            >
                                                {niveauxLangue?.map((niveauLg, j) => (
                                                    <MenuItem
                                                        value={niveauLg.value}
                                                        key={j}
                                                    > {niveauLg.label}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>
                                    </ThemeProvider>
                                </div>

                                <div style={{ width: device=='desktop'?'33%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                    <SelectComponent
                                        name='exigence'
                                        val={lang?.exigence}
                                        setVal={(e) => {
                                            let newArr = [...langues]; // copying the old datas array
                                            newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                            setLangues(newArr);
                                        }}
                                        listVal={exigencesEnum}
                                    />
                                </div>

                                <div className='btndelete'>
                                    <IconButton
                                        onClick={(e) => {
                                            // delete the index element by distructuring the array in two part without taking the i element
                                            let newArr1 = [
                                                ...langues.slice(0, i),
                                                ...langues.slice(i + 1, langues.length),
                                            ];
                                            setLangues(newArr1);
                                            console.log(e, langues);
                                        }}

                                        aria-label="delete"
                                    >
                                        <DeleteForeverOutlined />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                        <Button
                            style={{...buttonStyles(false),...{color:'#B0B0B0'}}}
                            variant="text"
                            startIcon={<Add />}
                            onClick={(e) => {
                                // e.preventDefault()
                                let index = langues.length;
                                let newArr = [...langues]; // copying the old datas array
                                newArr.push(initializeLangue(index));
                                // replace e.target.value with whatever you want to change it to
                                setLangues(newArr);
                                console.log(e, langues);
                            }}
                        >{i18n.t('Ajouter une langue')}</Button>

                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='frame36CvTheque'>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className='frame37CvTheque'
                >
                    <h6 className='frame38CvTheque'>{i18n.t('Certificats')}</h6>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='frame39CvTheque'>
                        {Array.isArray(certifs) && certifs.map((certif, i) => (
                            <div
                                key={i}
                                style={{
                                    display: 'flex',
                                    flexDirection:device=='desktop'? 'row':'column',
                                    justifyContent: 'space-between',
                                    alignSelf: 'stretch',
                                    gap: '16px',
                                }}
                            >
                                <div style={{ width: device=='desktop'?'48%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Intitulé')}</p>
                                    <TextFieldComponent
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', background: 'white' }}
                                        placeholder={i18n.t('Nom du certificat')}
                                        value={certif?.titre}
                                        onChange={(e) => {
                                            let newArr = [...certifs]; // copying the old datas array
                                            newArr[i].titre = e.target.value; // replace e.target.value with whatever you want to change it to
                                            setCertifs(newArr);
                                        }}
                                    />
                                </div>

                                <div style={{ width: device=='desktop'?'48%':'100%' }}>
                                    <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                    <SelectComponent
                                        name='exigence'
                                        val={certif?.exigence}
                                        setVal={(e) => {
                                            let newArr = [...certifs]; // copying the old datas array
                                            newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                            setCertifs(newArr);
                                        }}
                                        listVal={exigencesEnum}
                                    />

                                    {/* <ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}
                                                    title="exigence"
                                                    size={inputSize}
                                                    value={certif?.exigence}
                                                    onChange={(e) => {
                                                        let newArr = [...certifs]; // copying the old datas array
                                                        newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setCertifs(newArr);
                                                    }}
                                                >
                                                    {exigencesEnum.map((option) => (
                                                        <MenuItem
                                                            key={option.value}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>*/}

                                </div>
                                <div className='btndelete'>
                                    <IconButton
                                        onClick={(e) => {
                                            // delete the index element by distructuring the array in two part without taking the i element
                                            let newArr1 = [
                                                ...certifs.slice(0, i),
                                                ...certifs.slice(i + 1, certifs.length),
                                            ];
                                            setCertifs(newArr1);
                                            console.log(e, certifs);
                                        }}

                                        aria-label="delete"
                                    >
                                        <DeleteForeverOutlined />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                        <Button
                            variant="text"
                            style={{...buttonStyles(false),...{color:'#B0B0B0'}}}
                            startIcon={<Add />}
                            onClick={(e) => {
                                let index = certifs.length;
                                let newArr = [...certifs]; // copying the old datas array
                                newArr.push(initializeCertifCvTheque(index));
                                // replace e.target.value with whatever you want to change it to
                                setCertifs(newArr);
                                console.log(e, certifs);
                            }}
                        >
                            {i18n.t('Ajouter une qualification')}
                        </Button>

                    </div>
                </AccordionDetails>
            </Accordion>
            <div className='frame54CvTheque'>
                <div className='frame55CvTheque'>
                    <Button
                        type='submit'
                        variant='contained'
                        className='frame56CvTheque'
                        style={{ ...buttonStylesGreen(validateForm()),...{width:device=='desktop'?'auto':'100%'} }}
                        onClick={(e) => {
                            e.preventDefault();
                            search();
                        } }
                        disabled={validateForm()}
                    >
                        {i18n.t('Rechercher')}
                    </Button>
                </div>
            </div>
            <p className='frame57CvTheque'>
                {cvthequeExperts?.length} {i18n.t('résultats trouvés')}
            </p>

            <div
                className='frame4CvTheque'
                style={{flexDirection: 'row'}}
            >
                <div className='frame9CvTheque'>
                    <Tooltip title={i18n.t('Ajouter à un dossier')}>
                        <Button
                            variant='outlined'
                            style={{...buttonStyles(((selectedExperts.length > 0 )?false:true)),...{height:'36px'}}}
                            startIcon={<Add />}
                            onClick={() => (selectedExperts.length > 0) && setOpenClasser(true)}
                        >{device=='desktop' ? i18n.t('Ajouter à un dossier') : ''}</Button>
                    </Tooltip>
                </div>
                <div className='frame9CvTheque'>
                    <Tooltip title={i18n.t('Lier à un appel d\'offres')}>
                        <Button
                            variant='outlined'
                            startIcon={<Link />}
                            style={{...buttonStyles(((selectedExperts.length > 0 )?false:true)),...{height:'36px'}}}
                            onClick={() => (selectedExperts.length > 0) && setOpenLier(true)}
                        >{device=='desktop' ? i18n.t('Lier à un appel d\'offres') : ''}</Button>
                    </Tooltip>
                </div>
            </div>
            <div className='HomeFrame'>
                <MaterialTableComponent
                    columns={cvThequeColumns}
                    data={cvthequeExperts}
                    title="Cvtheque"
                    options={{
                        selection: true
                    }}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    key={ListStatutCv.length}
                    selectedRow={selectedRow}
                    onSelectionChange={(rows) => {
                        console.log({ rows });
                        setSelectedExperts(rows);
                    }}
                />

                <CvAnonyme
                    setOpenCvAnonyme={setCvOpen}
                    expert={expert}
                    openCvAnonyme={cvOpen}
                    refreshParentTable={search}
                    visualiseCvOnly={true}
                    necessaryRefresh={false}
                >
                </CvAnonyme>
                {openClasser &&
                    <DialogClasserCvs
                        selectedExperts={selectedExperts}
                        openClasser={openClasser}
                        handleCloseClasser={() => setOpenClasser(false)}
                    />}
                {openLier &&
                    <DialogLierCvs
                        selectedExperts={selectedExperts}
                        openLier={openLier}
                        setOpenLier={setOpenLier}
                    />}
            </div>
        </>
    );
}

export default CvThequeAdvancedSearch;